<!--
  设置金额
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="$t('home.setAmount')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <van-cell-group>
        <van-field
          v-model="money"
          :label="$t('home.amount')"
          type="number"
          :formatter="_formatter"
          :placeholder="$t('common.enterAmount')"
          clearable
        >
          <span slot="right-icon">P</span>
        </van-field>
        <van-field
          v-if="remarkFlag"
          v-model="remark"
          :label="$t('home.reason')"
          :placeholder="$t('home.enterReason')"
          clearable
        />
        <p class="add-remark" v-else>
          <span class="text-blue" @click="remarkFlag = true">
            {{ $t("home.addReason") }}
          </span>
        </p>
      </van-cell-group>
      <div class="button-wrap">
        <van-button block type="primary" :loading="btnLoading" @click="submit">
          {{ $t("common.confirm") }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      money: "",
      remark: "",
      remarkFlag: false,
      btnLoading: false
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:moneyFlag", false);
    },
    submit() {
      // 提交
      let vm = this;
      let data = {};
      if (vm.money == "" || vm.money == 0 || vm.money == null) {
        vm.$toast(vm.$t("common.enterAmount"));
        return;
      }
      if (vm.money < 0 || isNaN(vm.money)) {
        vm.$toast(vm.$t("common.enterCorrectAmount"));
        return;
      }
      data.money = Number(this.money).toFixed(2);
      data.remark = this.remark;
      this.$emit("getMoneyInfo", data);
      this.$emit("update:moneyFlag", false);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/.van-cell-group {
  padding: 10px;
  &.van-hairline--top-bottom::after {
    content: normal;
  }
  .van-cell:last-child:after {
    display: inline-block;
  }
  .van-field__label {
    width: auto;
    margin-right: 20px;
    font-size: 14px;
  }
  .add-remark {
    padding-top: 5px;
    text-align: right;
  }
}
</style>
